import { FC, useEffect, useState } from "react";
import defaultPlaceholder from "../../public/favicon.png";

interface ImageWithPlaceholderProps {
    src: string;
    alt: string;
    className: string;
}

const ImageWithPlaceholder: FC<ImageWithPlaceholderProps> = ({ src, alt, className }) => {
  const [currentSrc, setCurrentSrc] = useState(src);
  const [showingPlaceholder, setShowingPlaceholder] = useState(false);

  useEffect(() => {
    setCurrentSrc(src);
    setShowingPlaceholder(false);
  }, [src]);

  return (
    <img
      className={className}
      src={currentSrc}
      alt={alt}
      style={{ opacity: showingPlaceholder ? '10%' : '100%' }}
      loading="lazy" //Images that are not visible immediately are only loaded when the user scrolls to them. Big performance boost for pages with lots of images.
      decoding="async"
      onLoad={() => {
        if (currentSrc !== defaultPlaceholder) {
          setShowingPlaceholder(false);
        }
      }}
      onError={() => {
        setCurrentSrc(defaultPlaceholder);
        setShowingPlaceholder(true);
      }}
    />
  );
};

export default ImageWithPlaceholder;
